import React, { useState, createElement } from 'react';
import { DownloadIcon, CalendarIcon } from 'lucide-react';
interface PayoutEntry {
  merchantEntity: string;
  payoutId: string;
  payoutStatus: 'Paid' | 'Pending' | 'Failed';
  payoutEffectiveDate: string;
  currency: string;
  grossAmount: number;
  totalDeductions: number;
  netAmount: number;
  destinationAccount: string;
  description: string;
  externalPayoutReference: string;
}
interface PayoutTransaction {
  activityType: 'Payment' | 'Refund' | 'Fee' | 'Chargeback' | 'Adjustment';
  sourceActivityId: string;
  currency: string;
  grossAmount: number;
  totalDeductions: number;
  netAmount: number;
  description: string;
  originalPaymentReference: string;
  orderId: string;
  merchantReferenceId: string;
}
const allPayouts: PayoutEntry[] = [{
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '69a608748649da0d81711cc',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 6, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 3 for 6 Dec 2025 ...',
  externalPayoutReference: 'KBANK-20251206-TXN-00184'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '69a608748649da0d81712dd',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 6, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 3 for 6 Dec 2025...',
  externalPayoutReference: 'KBANK-20251206-TXN-00184'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '69a608748649da0d81713ee',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 6, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1847300.0,
  totalDeductions: 53572.7,
  netAmount: 1793727.3,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '3 of 3 for 6 Dec 2025...',
  externalPayoutReference: 'KBANK-20251206-TXN-00184'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '7a1b2c3d4e5f60718a9b0c1',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 5, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1245080.0,
  totalDeductions: 36107.32,
  netAmount: 1208972.68,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 5 Dec 2025 ...',
  externalPayoutReference: 'KBANK-20251205-TXN-00183'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '8b2c3d4e5f6a71829c0d1e2',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 4, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 3 for 4 Dec 2025 ...',
  externalPayoutReference: 'KBANK-20251204-TXN-00179'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '8b2c3d4e5f6a71829c0d2f3',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 4, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 3 for 4 Dec 2025...',
  externalPayoutReference: 'KBANK-20251204-TXN-00179'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '8b2c3d4e5f6a71829c0d3g4',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 4, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 210500.0,
  totalDeductions: 6104.5,
  netAmount: 204395.5,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '3 of 3 for 4 Dec 2025...',
  externalPayoutReference: 'KBANK-20251204-TXN-00179'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '9c3d4e5f6g7h81930k1l2m3',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 3, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 875000.0,
  totalDeductions: 25375.0,
  netAmount: 849625.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 3 Dec 2025 ...',
  externalPayoutReference: 'KBANK-20251203-TXN-00175'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: '0d4e5f6g7h8i92041l2m3n4',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 2, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 567120.0,
  totalDeductions: 16446.48,
  netAmount: 550673.52,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 2 Dec 2025 ...',
  externalPayoutReference: 'KBANK-20251202-TXN-00172'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'ae5f6g7h8i9j03152m3n4o5',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 1, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1530000.0,
  totalDeductions: 44370.0,
  netAmount: 1485630.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 2 for 1 Dec 2025 ...',
  externalPayoutReference: 'KBANK-20251201-TXN-00168'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'bf6g7h8i9j0k14263n4o5p6',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Dec 1, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 980500.0,
  totalDeductions: 28434.5,
  netAmount: 952065.5,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 2 for 1 Dec 2025...',
  externalPayoutReference: 'KBANK-20251201-TXN-00168'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'cg7h8i9j0k1l25374o5p6q7',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 30, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 3 for 30 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251130-TXN-00165'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'dh8i9j0k1l2m36485p6q7r8',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 30, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 3 for 30 Nov 2025...',
  externalPayoutReference: 'KBANK-20251130-TXN-00165'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'ei9j0k1l2m3n47596q7r8s9',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 30, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 742650.0,
  totalDeductions: 21536.85,
  netAmount: 721113.15,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '3 of 3 for 30 Nov 2025...',
  externalPayoutReference: 'KBANK-20251130-TXN-00165'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'fj0k1l2m3n4o586a7r8s9t0',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 28, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1125000.0,
  totalDeductions: 32625.0,
  netAmount: 1092375.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 28 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251128-TXN-00160'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'gk1l2m3n4o5p697b8s9t0u1',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 26, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1890000.0,
  totalDeductions: 54810.0,
  netAmount: 1835190.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 2 for 26 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251126-TXN-00155'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'hl2m3n4o5p6q708c9t0u1v2',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 26, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 435200.0,
  totalDeductions: 12620.8,
  netAmount: 422579.2,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 2 for 26 Nov 2025...',
  externalPayoutReference: 'KBANK-20251126-TXN-00155'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'im3n4o5p6q7r819d0u1v2w3',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 24, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 650000.0,
  totalDeductions: 18850.0,
  netAmount: 631150.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 24 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251124-TXN-00150'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'jn4o5p6q7r8s920e1v2w3x4',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 22, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 2000000.0,
  totalDeductions: 58000.0,
  netAmount: 1942000.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 2 for 22 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251122-TXN-00145'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'ko5p6q7r8s9t031f2w3x4y5',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 22, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 315700.0,
  totalDeductions: 9155.3,
  netAmount: 306544.7,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 2 for 22 Nov 2025...',
  externalPayoutReference: 'KBANK-20251122-TXN-00145'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'lp6q7r8s9t0u142g3x4y5z6',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 20, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1450000.0,
  totalDeductions: 42050.0,
  netAmount: 1407950.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 20 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251120-TXN-00140'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'mq7r8s9t0u1v253h4y5z6a7',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 18, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 780000.0,
  totalDeductions: 22620.0,
  netAmount: 757380.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 1 for 18 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251118-TXN-00135'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'nr8s9t0u1v2w364i5z6a7b8',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 15, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 1680000.0,
  totalDeductions: 48720.0,
  netAmount: 1631280.0,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '1 of 2 for 15 Nov 2025 ...',
  externalPayoutReference: 'KBANK-20251115-TXN-00130'
}, {
  merchantEntity: 'Siam Fresh Market Co., Ltd.',
  payoutId: 'os9t0u1v2w3x475j6a7b8c9',
  payoutStatus: 'Paid',
  payoutEffectiveDate: 'Nov 15, 2025 15:00:00 ICT',
  currency: 'THB',
  grossAmount: 520370.0,
  totalDeductions: 15090.73,
  netAmount: 505279.27,
  destinationAccount: 'KASIKORNBANK •••• 1005',
  description: '2 of 2 for 15 Nov 2025...',
  externalPayoutReference: 'KBANK-20251115-TXN-00130'
}];
const PAGE_SIZE = 9;
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};
// Compute summary card values
const last7DaysPayouts = allPayouts.filter(p => {
  // Nov 30 – Dec 6 range
  const dateStr = p.payoutEffectiveDate;
  return dateStr.includes('Dec 6') || dateStr.includes('Dec 5') || dateStr.includes('Dec 4') || dateStr.includes('Dec 3') || dateStr.includes('Dec 2') || dateStr.includes('Dec 1') || dateStr.includes('Nov 30');
});
const last30DaysPayouts = allPayouts;
const CSV_HEADERS = ['Merchant Entity', 'Payout ID', 'Payout Status', 'Payout Effective Date', 'Currency', 'Gross Amount', 'Total Deductions', 'Net Amount', 'Destination Account', 'Description', 'External Payout Reference'];
function payoutToCsvRow(entry: PayoutEntry): string {
  return [`"${entry.merchantEntity}"`, entry.payoutId, entry.payoutStatus, `"${entry.payoutEffectiveDate}"`, entry.currency, entry.grossAmount.toFixed(2), entry.totalDeductions.toFixed(2), entry.netAmount.toFixed(2), `"${entry.destinationAccount}"`, `"${entry.description}"`, entry.externalPayoutReference].join(',');
}
function downloadCsv(filename: string, entries: PayoutEntry[]) {
  const csvContent = [CSV_HEADERS.join(','), ...entries.map(payoutToCsvRow)].join('\n');
  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
// --- Payout Detail Report (per-payout transaction-level CSV) ---
const DETAIL_CSV_HEADERS = ['Merchant entity', 'Payout ID', 'Payout status', 'Payout effective date', 'Activity type', 'Source activity ID', 'Currency', 'Gross amount', 'Total deductions', 'Net amount', 'Destination account', 'Description', 'Original payment reference', 'Order ID', 'Merchant reference ID'];
function generateMockTransactions(payout: PayoutEntry): PayoutTransaction[] {
  // Deterministic seed from payoutId
  const seed = payout.payoutId.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  const rng = (i: number) => {
    const x = Math.sin(seed + i) * 10000;
    return x - Math.floor(x);
  };
  const transactions: PayoutTransaction[] = [];
  let remainingGross = payout.grossAmount;
  let remainingDeductions = payout.totalDeductions;
  const paymentDescriptions = ['Weekly grocery order - fresh produce', 'Bulk rice and noodles purchase', 'Seafood platter catering order', 'Office lunch delivery - 25 pax', 'Monthly subscription box - premium', 'Fruit basket gift set x3', 'Restaurant supply restock', 'Weekend market stall rental', 'Organic vegetables wholesale', 'Frozen goods monthly order', 'Beverage supply - soft drinks and water', 'Bakery ingredients wholesale order', 'Meat and poultry weekly supply', 'Dairy products - milk and cheese', 'Snack hamper corporate gift', 'Cooking oil and condiments restock', 'Party catering - 50 guests', 'Hotel breakfast buffet supply', 'School canteen weekly provisions', 'Festival special menu ingredients'];
  // Generate 8-15 payment transactions
  const paymentCount = 8 + Math.floor(rng(0) * 8);
  const basePaymentAmount = payout.grossAmount / paymentCount;
  for (let i = 0; i < paymentCount; i++) {
    const isLast = i === paymentCount - 1;
    const variation = isLast ? remainingGross : Math.round(basePaymentAmount * (0.5 + rng(i + 10)) * 100) / 100;
    const gross = Math.max(100, Math.min(variation, remainingGross));
    const actualGross = isLast ? remainingGross : Math.round(gross * 100) / 100;
    const feeRate = 0.029 + rng(i + 50) * 0.005;
    const deduction = isLast ? remainingDeductions : Math.round(actualGross * feeRate * 100) / 100;
    const net = Math.round((actualGross - deduction) * 100) / 100;
    remainingGross = Math.round((remainingGross - actualGross) * 100) / 100;
    remainingDeductions = Math.round((remainingDeductions - deduction) * 100) / 100;
    const txnNum = String(10000 + Math.floor(rng(i + 20) * 90000));
    const ordNum = String(10000 + Math.floor(rng(i + 30) * 90000));
    const merchRef = `MR-${String(1000 + Math.floor(rng(i + 40) * 9000))}`;
    transactions.push({
      activityType: 'Payment',
      sourceActivityId: `pay_${txnNum}`,
      currency: payout.currency,
      grossAmount: actualGross,
      totalDeductions: deduction,
      netAmount: net,
      description: paymentDescriptions[Math.floor(rng(i + 60) * paymentDescriptions.length)],
      originalPaymentReference: `txn_${txnNum}`,
      orderId: `ord_${ordNum}`,
      merchantReferenceId: merchRef
    });
  }
  const refundDescriptions = ['Refund due to damaged goods on delivery', 'Customer cancelled order before dispatch', 'Incorrect items shipped - full refund issued', 'Product quality below expectation', 'Duplicate charge - refund processed', 'Partial refund for missing items in order', 'Order arrived late - goodwill refund', 'Customer changed mind within return window', 'Spoiled produce on arrival', 'Wrong quantity delivered - overcharge refund'];
  // Add 1-3 refunds (small amounts, negative)
  const refundCount = 1 + Math.floor(rng(100) * 3);
  for (let i = 0; i < refundCount; i++) {
    const refundAmount = Math.round((500 + rng(i + 200) * 5000) * 100) / 100;
    const refundNum = String(10000 + Math.floor(rng(i + 210) * 90000));
    const origTxn = transactions[Math.floor(rng(i + 220) * Math.min(3, transactions.length))];
    const refundFee = Math.round(refundAmount * (0.015 + rng(i + 240) * 0.01) * 100) / 100;
    transactions.push({
      activityType: 'Refund',
      sourceActivityId: `rf_${refundNum}`,
      currency: payout.currency,
      grossAmount: -refundAmount,
      totalDeductions: refundFee,
      netAmount: Math.round((-refundAmount - refundFee) * 100) / 100,
      description: refundDescriptions[Math.floor(rng(i + 230) * refundDescriptions.length)],
      originalPaymentReference: origTxn?.originalPaymentReference || `txn_${refundNum}`,
      orderId: origTxn?.orderId || `ord_${refundNum}`,
      merchantReferenceId: origTxn?.merchantReferenceId || `MR-${refundNum}`
    });
  }
  const chargebackDescriptions = ['Customer disputes charge - item not received', 'Unauthorized transaction reported by cardholder', 'Service not as described - dispute filed', 'Cardholder does not recognize transaction'];
  // Occasionally add a chargeback
  if (rng(300) > 0.6) {
    const cbAmount = Math.round((1000 + rng(310) * 8000) * 100) / 100;
    const cbNum = String(10000 + Math.floor(rng(320) * 90000));
    const origTxn = transactions[Math.floor(rng(330) * Math.min(2, transactions.length))];
    const cbFee = Math.round(cbAmount * (0.02 + rng(350) * 0.015) * 100) / 100;
    transactions.push({
      activityType: 'Chargeback',
      sourceActivityId: `cb_${cbNum}`,
      currency: payout.currency,
      grossAmount: -cbAmount,
      totalDeductions: cbFee,
      netAmount: Math.round((-cbAmount - cbFee) * 100) / 100,
      description: chargebackDescriptions[Math.floor(rng(340) * chargebackDescriptions.length)],
      originalPaymentReference: origTxn?.originalPaymentReference || `txn_${cbNum}`,
      orderId: origTxn?.orderId || `ord_${cbNum}`,
      merchantReferenceId: origTxn?.merchantReferenceId || `MR-${cbNum}`
    });
  }
  const adjustmentDescriptions = ['Currency conversion rounding correction', 'Processing fee credit - promotional rate', 'Settlement timing adjustment', 'Volume discount rebate applied'];
  // Add an adjustment if needed
  if (rng(400) > 0.5) {
    const adjAmount = Math.round((100 + rng(410) * 2000) * 100) / 100;
    const adjNum = String(10000 + Math.floor(rng(420) * 90000));
    transactions.push({
      activityType: 'Adjustment',
      sourceActivityId: `adj_${adjNum}`,
      currency: payout.currency,
      grossAmount: rng(430) > 0.5 ? adjAmount : -adjAmount,
      totalDeductions: 0,
      netAmount: rng(430) > 0.5 ? adjAmount : -adjAmount,
      description: adjustmentDescriptions[Math.floor(rng(440) * adjustmentDescriptions.length)],
      originalPaymentReference: '',
      orderId: '',
      merchantReferenceId: ''
    });
  }
  return transactions;
}
function escCsv(val: string | number): string {
  const s = String(val);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}
function downloadPayoutDetailCsv(payout: PayoutEntry) {
  const transactions = generateMockTransactions(payout);
  const rows = transactions.map(txn => [escCsv(payout.merchantEntity), escCsv(payout.payoutId), escCsv(payout.payoutStatus), escCsv(payout.payoutEffectiveDate), escCsv(txn.activityType), escCsv(txn.sourceActivityId), escCsv(txn.currency), txn.grossAmount.toFixed(2), txn.totalDeductions.toFixed(2), txn.netAmount.toFixed(2), escCsv(payout.destinationAccount), escCsv(txn.description), escCsv(txn.originalPaymentReference), escCsv(txn.orderId), escCsv(txn.merchantReferenceId)].join(','));
  const csvContent = [DETAIL_CSV_HEADERS.join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], {
    type: 'text/csv;charset=utf-8;'
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `payout-detail-${payout.payoutId}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
export function Payouts() {
  const [currentPage, setCurrentPage] = useState(1);
  const totalEntries = allPayouts.length;
  const totalPages = Math.ceil(totalEntries / PAGE_SIZE);
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const endIndex = Math.min(startIndex + PAGE_SIZE, totalEntries);
  const currentEntries = allPayouts.slice(startIndex, endIndex);
  const last7Total = last7DaysPayouts.reduce((sum, p) => sum + p.grossAmount, 0);
  const last30Total = last30DaysPayouts.reduce((sum, p) => sum + p.grossAmount, 0);
  return <div className="max-w-7xl mx-auto" data-id="element-9736">
      {/* Header */}
      <div className="flex items-center justify-between mb-8" data-id="element-9737">
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-9738">Payouts</h1>
        <button onClick={() => downloadCsv('payouts-export.csv', allPayouts)} className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm" data-id="element-9739">
          <DownloadIcon size={16} data-id="element-9740" />
          Export
        </button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-9741">
        <div className="bg-white border border-gray-200 rounded-lg p-5" data-id="element-9742">
          <div className="flex items-center justify-between mb-3" data-id="element-9743">
            <span className="text-sm text-gray-500" data-id="element-9744">Last 7 days</span>
            <CalendarIcon size={16} className="text-gray-400" data-id="element-9745" />
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-1" data-id="element-9746">
            THB {formatCurrency(last7Total)}
          </div>
          <div className="text-sm text-gray-500" data-id="element-9747">
            {last7DaysPayouts.length} payouts · Nov 30 – Dec 6, 2025
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg p-5" data-id="element-9748">
          <div className="flex items-center justify-between mb-3" data-id="element-9749">
            <span className="text-sm text-gray-500" data-id="element-9750">Last 30 days</span>
            <CalendarIcon size={16} className="text-gray-400" data-id="element-9751" />
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-1" data-id="element-9752">
            THB {formatCurrency(last30Total)}
          </div>
          <div className="text-sm text-gray-500" data-id="element-9753">
            {last30DaysPayouts.length} payouts · Nov 7 – Dec 6, 2025
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-gray-200 rounded-lg" data-id="element-9754">
        <div className="overflow-x-auto" data-id="element-9755">
          <table className="w-full" data-id="element-9756">
            <thead data-id="element-9757">
              <tr className="border-b border-gray-200 bg-gray-50/50" data-id="element-9758">
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9759">
                  Merchant entity
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9760">
                  Payout ID
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9761">
                  Payout status
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9762">
                  Payout effective date
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9763">
                  Currency
                </th>
                <th className="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9764">
                  Gross amount
                </th>
                <th className="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9765">
                  Total deductions
                </th>
                <th className="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9766">
                  Net amount
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9767">
                  Destination account
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9768">
                  Description
                </th>
                <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9769">
                  External payout reference
                </th>
                <th className="text-center px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-9770">
                  Report
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-9771">
              {currentEntries.map((entry, index) => <tr key={`${entry.payoutId}-${index}`} className="hover:bg-gray-50/50 transition-colors" data-id="element-9772">
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap max-w-[160px] truncate" data-id="element-9773">
                    {entry.merchantEntity.length > 20 ? entry.merchantEntity.substring(0, 20) + '...' : entry.merchantEntity}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-500 font-mono whitespace-nowrap" data-id="element-9774">
                    {entry.payoutId}
                  </td>
                  <td className="px-5 py-4 whitespace-nowrap" data-id="element-9775">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-9776">
                      {entry.payoutStatus}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap" data-id="element-9777">
                    {entry.payoutEffectiveDate}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap" data-id="element-9778">
                    {entry.currency}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-900 text-right whitespace-nowrap" data-id="element-9779">
                    THB {formatCurrency(entry.grossAmount)}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 text-right whitespace-nowrap" data-id="element-9780">
                    THB {formatCurrency(entry.totalDeductions)}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-900 font-semibold text-right whitespace-nowrap" data-id="element-9781">
                    THB {formatCurrency(entry.netAmount)}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap" data-id="element-9782">
                    {entry.destinationAccount}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-700 whitespace-nowrap max-w-[200px] truncate" data-id="element-9783">
                    {entry.description}
                  </td>
                  <td className="px-5 py-4 text-sm text-gray-500 font-mono whitespace-nowrap" data-id="element-9784">
                    {entry.externalPayoutReference}
                  </td>
                  <td className="px-5 py-4 text-center whitespace-nowrap" data-id="element-9785">
                    <button onClick={() => downloadPayoutDetailCsv(entry)} className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-gray-600 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors" data-id="element-9786">
                      <DownloadIcon size={12} data-id="element-9787" />
                      .csv
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between px-5 py-4 border-t border-gray-200" data-id="element-9788">
          <span className="text-sm text-gray-500" data-id="element-9789">
            Showing {startIndex + 1} to {endIndex} of {totalEntries} entries
          </span>
          <div className="flex items-center gap-2" data-id="element-9790">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-9791">
              Previous
            </button>
            <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-9792">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}